import { render, staticRenderFns } from "./SmaPlansList.vue?vue&type=template&id=c808be88"
import script from "./SmaPlansList.vue?vue&type=script&lang=js"
export * from "./SmaPlansList.vue?vue&type=script&lang=js"
import style0 from "./SmaPlansList.vue?vue&type=style&index=0&id=c808be88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports